import type React from "react";

import { useTranslation } from "react-i18next";

import { ColumnContainer } from "routes/library/components";
import { FormPreviewContainer } from "routes/library/components/styles";
import { ActivityItem } from "shared/atoms/PatientApp";

import type { ExerciseLevelSubset } from "./ExercisePreviewMobile";
import { ExercisePreviewMobile } from "./ExercisePreviewMobile";
import type { PreviewTab } from "./ImageAndVideoContainer";

interface Props {
  exercise: { levels: ExerciseLevelSubset[] };
  image_url: string | null;
  isLoading: boolean;
  previewTab: PreviewTab;
}

export const PreviewColumn: React.FC<Props> = ({ exercise, image_url, isLoading, previewTab }) => {
  const { t } = useTranslation();

  return (
    <ColumnContainer heading={t("library.exercises.form.preview_header")}>
      <FormPreviewContainer>
        <ExercisePreviewMobile exercise={exercise} isLoading={isLoading} previewTab={previewTab} />
        <ActivityItem image_url={image_url} isLoading={isLoading} title={exercise.levels[0].title} type="exercise" />
      </FormPreviewContainer>
    </ColumnContainer>
  );
};
